import React from 'react';
import { Link } from 'react-router-dom';
import { getListYourGearDestination } from './navLinks';

function SiteFooter({ user }) {
  const listDestination = getListYourGearDestination(user);

  return (
    <footer className="site-footer">
      <p className="site-footer-mission">
        We built ATTACK! Your Adventure to help people get outside — new places, new activities,
        and real conversations with real people. Shared gear is the practical part; the goal is
        experience.
      </p>
      <nav className="site-footer-nav" aria-label="Footer">
        <Link to="/browse">Browse Gear</Link>
        <Link to="/#gear-wanted">Gear Wanted</Link>
        <Link to="/about">About</Link>
        <Link to="/faq">FAQ</Link>
        <Link to={listDestination}>List Your Gear</Link>
        <Link to="/rules">Rules</Link>
        <Link to="/terms">Terms of Service</Link>
        <Link to="/privacy">Privacy Policy</Link>
        <Link to="/contact">Contact</Link>
      </nav>
      <p className="site-footer-copy">
        © {new Date().getFullYear()} ATTACK! Your Adventure
      </p>
    </footer>
  );
}

export default SiteFooter;